import React from 'react';

import { SubscriberCouncilPartner } from '@utils/backend-api/partners';

import SubscriberCouncilCard from './SubscriberCouncilCard';

const SubscriberCouncilContainer = ({ scPartners }: { scPartners: SubscriberCouncilPartner[] }) => {
  return (
    <>
      <div className="flex w-full items-center justify-between px-20 sm:p-0">
        <h3 className="mr-20 whitespace-nowrap font-['Meta',Georgia,sans-serif] text-[18px] font-black text-primary-red">
          <span className="hidden sm:inline">The Information </span>Subscriber Council
        </h3>
        <div className="h-2 w-full bg-pro-red"></div>
      </div>
      <div className="mb-40 mt-0 px-20 sm:mb-48 sm:mt-12 sm:grid sm:grid-cols-2 sm:p-0">
        {scPartners.map((partner) => (
          <SubscriberCouncilCard key={`sc-card-${partner.id}`} partner={partner} />
        ))}
        <a
          className="border-0 border-l border-solid border-[#c4c6ce] py-3 pl-12 font-['Meta',Georgia,sans-serif] text-[14px] underline"
          href="/partners#partnerships"
        >
          Learn More
        </a>
      </div>
    </>
  );
};

export default SubscriberCouncilContainer;
